import ToastServive from 'react-material-toast';
const Toaster = ToastServive.new({
    place:'topRight',
    duration:2,
    maxCount:8
  });

export default Toaster